module.exports = __webpack_public_path__ + "static/media/m_b_45.3b41a067.png";